import {Box, P} from 'exsportia-components'
import React, {FC, ReactElement} from 'react'

import {GradientLoader} from '../gradient-loader/gradient-loader'

type Props = {
  image?: string;
  title?: string;
  subtitle?: ReactElement | string;
}

export const PreviewCard: FC<Props> = ({
  image,
  title = 'title',
  subtitle = 'subtitle',
}) => {
  return (
    <Box
      height={'208px'}
      width={'100%'}
      borderRadius={'16px'}
      overflow={'hidden'}
      border={'solid 1px #BFC1C755'}
      position={'relative'}
      background={`url(${image}) center center / cover no-repeat`}
    >
      {
        !image
        && (
          <GradientLoader
            height={'100%'}
            style={{
              width: '100%',
            }}
          />
        )
      }
      <Box
        position={'absolute'}
        height={'100%'}
        width={'100%'}
        top={'0px'}
      >
        <Box
          position={'absolute'}
          bottom={'0px'}
          padding={'16px'}
          width={'100%'}
          background='linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.7) 100%)'
        >
          {
            title
            && (
              <P
                color={'text-contrast'}
                fontSize={'h2'}
                fontWeight={'bold'}
              >
                {title}
              </P>
            )
          }
          {
            subtitle
            && (
              <P fontSize={'label'} color={'text-contrast'}>
                {subtitle}
              </P>
            )
          }
        </Box>
      </Box>
    </Box>
  )
}